import { render, staticRenderFns } from "./NewFQCAdminData.vue?vue&type=template&id=bf1a8a20&scoped=true"
import script from "./NewFQCAdminData.vue?vue&type=script&lang=js"
export * from "./NewFQCAdminData.vue?vue&type=script&lang=js"
import style0 from "./NewFQCAdminData.vue?vue&type=style&index=0&id=bf1a8a20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf1a8a20",
  null
  
)

export default component.exports